import { supabase } from './supabase';

export interface TaxonomyTerm {
  id: string;
  name: string;
  description: string | null;
  sector_id?: string;
}

export interface Sector {
  id: string;
  name: string;
  description: string | null;
}

export interface Subsector extends TaxonomyTerm {
  sector_id: string;
  sector_name?: string;
}

// Get all sectors
export const getSectors = async (): Promise<Sector[]> => {
  const { data, error } = await supabase
    .from('sectors')
    .select('*')
    .order('name');

  if (error) throw error;
  return data || [];
};

// Get subsectors by sector
export const getSubsectorsBySector = async (sectorId: string): Promise<Subsector[]> => {
  const { data, error } = await supabase
    .from('subsectors')
    .select('*')
    .eq('sector_id', sectorId)
    .order('name');

  if (error) throw error;
  return data || [];
};

// Get all subsectors with their sectors
export const getAllSubsectors = async (): Promise<Subsector[]> => {
  const { data, error } = await supabase
    .from('subsectors')
    .select(`
      *,
      sectors (
        id,
        name
      )
    `)
    .order('name');

  if (error) throw error;
  return data || [];
};

// Get all platforms
export const getPlatforms = async (): Promise<TaxonomyTerm[]> => {
  const { data, error } = await supabase
    .from('platforms')
    .select('*')
    .order('name');

  if (error) throw error;
  return data || [];
};

// Get all tools
export const getTools = async (): Promise<TaxonomyTerm[]> => {
  const { data, error } = await supabase
    .from('tools')
    .select('*')
    .order('name');

  if (error) throw error;
  return data || [];
};

// Get all programming languages
export const getProgrammingLanguages = async (): Promise<TaxonomyTerm[]> => {
  const { data, error } = await supabase
    .from('programming_languages')
    .select('*')
    .order('name');

  if (error) throw error;
  return data || [];
};

// Get all countries
export const getCountries = async (): Promise<TaxonomyTerm[]> => {
  const { data, error } = await supabase
    .from('countries')
    .select('*')
    .order('name');

  if (error) throw error;
  return data || [];
};

// Get all job functions
export const getJobFunctions = async (): Promise<TaxonomyTerm[]> => {
  const { data, error } = await supabase
    .from('job_functions')
    .select('*')
    .order('name');

  if (error) throw error;
  return data || [];
};

// Get all industries
export const getIndustries = async (): Promise<TaxonomyTerm[]> => {
  const { data, error } = await supabase
    .from('industries')
    .select('*')
    .order('name');

  if (error) throw error;
  return data || [];
};